module.exports = {
  Individual: 'อัน',
  AreYouWantToCopy: 'กรุณายืนยันว่าต้องการคัดลอกหรือไม่？',
  Hint: 'คำเตือน',
  Confirm: 'ตกลง',
  Cancel: 'ยกเลิก',
  BiDomainName: 'โดเมน BI',
  FillBiDomainName: 'กรุณากรอกโดเมน BI'
}
